/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { validator, buildValidations } from 'ember-cp-validations';

export default buildValidations({
  pageTargetString: {
    description: 'Page Target String',
    validators: [validator('page-target-string')],
  },
  pageTargetType: {
    description: 'Page Target Type',
    validators: [validator('number', { allowBlank: false, gte: 0, lte: 4 })],
  },
});
